module.exports = __webpack_public_path__ + "img/04.0923cbf3.png";